export const POST_SURVEY = 'pages/survey/stakeholder'

export const GET_SURVEY_DETAILS = 'pages/survey/first-name'
